import Image from 'next/image'
import GoldLinkButton from '../GoldLinkButton'
import TextWithLineBreaks from '../TextWithlineBreak'
import defaultDubaiImg from 'images/homepageimg.webp'

const MainSection = ({
  homepage = false,
  dynamicValues = null,
  isShowButtons = true,
  t,
  textHasLineBreak = false,
  chauffeurServicesPageLayout = false,
  imgSrc,
  locale = '',
  singleCityPage = false,
}) => {
  const isPortuguese = locale === 'pt-BR'
  return (
    <div className='main-section'>
      <div className='w-full h-full max-w-full relative'>
        {!homepage ? (
          <Image
            quality={100}
            className='hero-img h-auto w-auto max-w-full'
            priority
            placeholder='blur'
            src={imgSrc}
            alt='Elevate your journey with Rolzo'
          />
        ) : (
          <Image
            src={imgSrc}
            alt='Elevate your journey with Rolzo'
            width={0} // Set width and height to 0
            height={0}
            sizes='100vw' // Image will be 100% of viewport width
            style={{ width: '100%', height: 'auto' }}
            priority
            quality={100}
            className='hero-img object-contain w-full h-auto xl:max-h-[688.57px] xl:max-w-[1111.4px]'
          />
        )}
      </div>
      {!chauffeurServicesPageLayout && (
        <div className='mx-[15px] md:m-0  mb-8 md:mb-0 xl:flex xl:flex-col xl:items-center xl:text-center md:mt-12 '>
          <h1 className='header'>{t('title')}</h1>
          <TextWithLineBreaks
            dynamicValues={dynamicValues}
            t={t}
            elementClassName={`text ${singleCityPage ? '!text-[18px] md:!text-[16px]' : ''}`}
            textKey='text'
            lineBreakClassname='hidden md:block'
            element='p'
          />
          {isShowButtons && (
            <div
              className={`btns-container text-center ${isPortuguese ? 'is-portuguese' : ''}`}
            >
              <GoldLinkButton
                isNewTab
                href='https://business.rolzo.com/auth/register'
                hasGoldBackground
                text='Start now'
              />
              <GoldLinkButton
                hasGoldBackground={false}
                href='/contact'
                text='Contact us'
              />
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default MainSection







//  {chauffeurServicesPageLayout && (
//         <div className='mx-[15px] md:m-0  mb-8 md:mb-0 chauffeur-services-page-layout'>
//           <h1 className='header'>{t('title')}</h1>
//           <TextWithLineBreaks
//             dynamicValues={dynamicValues}
//             t={t}
//             elementClassName='text'
//             textKey='text'
//             lineBreakClassname='hidden md:block'
//             element='p'
//           />
//         </div>
//       )}